import React from "react";
import { style } from "typestyle";
import UploadButton from "./UploadButton";
import { Feature, FeatureCollection, Polygon } from "geojson";

import { kml } from "@tmcw/togeojson";

import filterPolygons from "../../filterPolygons";
import removePolygonHeights from "../../removePolygonHeights";

interface IUploadButtonsControlProps {
  onGeoJsonUploaded: (geoJson: Feature<Polygon>) => void;
  onlyKml?: boolean;
}

const UploadButtonsControl = ({
  onGeoJsonUploaded,
  onlyKml,
}: IUploadButtonsControlProps) => (
  <div
    className={style({
      $nest: {
        "&>*": {
          marginLeft: "12px",
        },
      },
    })}
  >
    <UploadButton
      onFileSelected={(text) => {
        try {
          const xml = new DOMParser().parseFromString(text, "text/xml");
          const geoJson = kml(xml) as FeatureCollection;
          try {
            return onGeoJsonUploaded(
              removePolygonHeights(filterPolygons(geoJson)),
            );
          } catch (e) {
            alert(e.message);
          }
        } catch (e) {
          alert("Could not parse file");
        }
      }}
      onError={(errorMessage) => alert(errorMessage)}
      label="KML"
    />
    {!onlyKml && (
      <UploadButton
        onFileSelected={(text) => {
          try {
            const json = JSON.parse(text);
            try {
              return onGeoJsonUploaded(
                removePolygonHeights(filterPolygons(json)),
              );
            } catch (e) {
              alert(e.message);
            }
          } catch (e) {
            alert("Could not parse file");
          }
        }}
        onError={(errorMessage) => alert(errorMessage)}
        label="GeoJSON"
      />
    )}
  </div>
);

export default UploadButtonsControl;
